// authConfig.js
function $jsonParse(jsonString) {
    try {
        return JSON.parse(jsonString);
    } catch (error) {
        console.error('解析JSON时出错:', error);
        return null;
    }
}

function $isBlank(value) {
    const emptyValues = [null, "null", "NULL", "undefined", undefined, 'UNDEFINED', ''];
    if (emptyValues.includes(value)) {
        return true;
    }
    if (Array.isArray(value) && value.length === 0) {
        return true;
    }
    if (typeof value === 'object' && value !== null && Object.keys(value).length === 0 && value.constructor === Object) {
        return true;
    }
    return false;
}

const authConfig = {
    install(Vue, options) {
        try {
            const userJson = localStorage.getItem('user');
            const user = $jsonParse(userJson);

            if ($isBlank(user)) {
                Vue.prototype.$A = {};
                Vue.prototype.$U = {};
            } else {
                Vue.prototype.$A = user.auth || {};
                Vue.prototype.$U = user || {};
            }
        } catch (error) {
            console.error('处理用户信息时出错:', error);
            Vue.prototype.$A = {};
        }
    },
};

export default authConfig;